export const getSafePostLoginPath = (value) => {
  if (typeof value !== 'string') return '/dashboard';

  const candidate = value.trim();
  const isLocalAbsolutePath = /^\/(?!\/)/.test(candidate);
  const containsControlCharacter = Array.from(value).some((character) => {
    const codePoint = character.codePointAt(0);
    return codePoint <= 31 || codePoint === 127;
  });
  const containsUnsafeCharacters = candidate.includes('\\') || containsControlCharacter;

  return isLocalAbsolutePath && !containsUnsafeCharacters ? candidate : '/dashboard';
};
